// @flow
/**
 * The default font size of basically any known browser is `16px`
 *
 * @private
 */
// eslint-disable-next-line import/prefer-default-export
export const DEFAULT_BROWSER_FONT_SIZE: 16 = 16;
